module.exports = __webpack_public_path__ + "static/media/logServos.6de8459d.svg";